const holds = new Set();
export const UPDATE_SAFETY_EVENT = "helios:page-update-safety";

export function holdPageUpdate(token, blocked) {
  if (blocked) holds.add(token); else holds.delete(token);
  window.dispatchEvent(new Event(UPDATE_SAFETY_EVENT));
}

export function pageUpdateBlocked(doc = document, pathname = window.location.pathname) {
  if (holds.size || pathname.startsWith("/admin")) return true;
  if (doc.querySelector('[role="dialog"][data-state="open"], form[aria-busy="true"]')) return true;
  return [...doc.querySelectorAll("input, textarea, select, [contenteditable=true]")].some(field => {
    if (field.closest('[data-testid="site-update-notice"], [data-update-safe="true"]')) return false;
    if (field.isContentEditable) return Boolean(field.textContent.trim());
    if (["hidden", "button", "submit", "reset", "range"].includes(field.type)) return false;
    if (["checkbox", "radio"].includes(field.type)) return field.checked !== field.defaultChecked;
    if (field.tagName === "SELECT") return field.selectedIndex > 0;
    return Boolean(field.value?.trim());
  });
}